import React from "react";
import { Box, Grid } from "@mui/material";
import useSavePatient from "src/Patient/hooks/useSavePatient";
import FormCreatePassword from "src/Patient/register/components/FormCreatePassword";
import ButtonCustom from "src/shared/components/buttons/ButtonCustom";

const FormResetPasswordProfile = () => {
  const { handleClickResetPasswordProfile, loading } = useSavePatient();

  return (
    <div className="animate__animated animate__fadeIn">
      <FormCreatePassword />
      <Grid container display={"flex"} justifyContent={"center"} p={2} mt={1}>
        <Box>
          <ButtonCustom
            color="secondary"
            loading={loading}
            text="CAMBIAR CLAVE"
            //icon={<NavigateNextIcon />}
            onClick={handleClickResetPasswordProfile}
          />
        </Box>
      </Grid>
    </div>
  );
};

export default FormResetPasswordProfile;
